export const requestId = store => store.value.requests.request.id;
export const getRequest = store => store.value.requests.request;
export const isEditMode = () => window.location.href.includes('edit');
